import { t } from '@lingui/macro';

/**
 * Translate a Fleet Admin capability denial into user-facing copy.
 *
 * The backend returns the denial reason as a symbolic enum
 * (`FleetAdminDeniedReason`); the UI owns the localized strings. Product
 * decided every denial — including the `null`/`undefined` fallback used by
 * the synthetic-denied capability — surfaces the same generic message, since
 * end users have no context for the underlying Portal role names.
 */
export default function fleetAdminDeniedReasonText(
  _reason: FleetAdminDeniedReason | null | undefined,
): string {
  return t`You don't have permission to perform this action. Contact your account administrator.`;
}
